/**
 * 快捷建议项
 */
export interface ShortcutSuggestionItem {
  /** 显示文本 */
  text: string;
  /** 唯一标识（可选，有则可请求详情） */
  id?: string;
}

/**
 * 快捷建议Data
 */
export interface ShortcutSuggestionData {
  suggestions: ShortcutSuggestionItem[];
  projectId: string;
  sessionId: string;
  messageId: string;
  timestamp: number;
}

/**
 * 快捷建议事件负载
 */
export interface ShortcutSuggestionEventPayload {
  data: ShortcutSuggestionData;
  timestamp: number;
}

/**
 * 快捷指令发送参数
 */
export interface ShortcutSuggestionSendParams {
  /** 唯一 key（id ?? text），用于标识已选状态 */
  key: string;
  /** 实际发送给 Agent 的文本 */
  agentRequestText: string;
  /** 显示在 UI 上的文本 */
  displayText: string;
}

export interface QuickPromptsProps {
  /** 点击快捷入口发送消息的回调（无 id 时直接发送） */
  onSend?: (params: ShortcutSuggestionSendParams) => void;
  /** 填充输入框的回调（有 id 时填充匹配到的内容） */
  onFillInput?: (text: string) => void;
  /** 已选中的 shortcut key 列表（id ?? text），对应按钮不再显示 */
  selectedKeys?: string[];
}

/**
 * localStorage 统一存储 key，避免按 projectId 拆分导致 key 数膨胀
 */
export const SHORTCUT_SUGGESTIONS_STORAGE_KEY = 'wegic_shortcut_suggestions';

/**
 * 快捷指令缓存最多保留项目数
 */
export const SHORTCUT_SUGGESTIONS_STORAGE_MAX_PROJECTS = 5;
